import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-progress',
  templateUrl: './loading-progress.component.html',
  styleUrl: './loading-progress.component.scss'
})
export class LoadingProgressComponent {

}
